export const apps = Array.from({
  length: 5
}).fill({
  tileData: {
    id: '1217110',
    addonId: 1217110,
    addonKey: 'atlassian-jira-training',
    name: 'Training for Jira',
    tagLine: 'Jira User Training ‒ Give your team access to dozens of short, interactive tutorials to get them using Jira',
    deployments: ['cloud', 'server', 'dataCenter'],
    documentType: 'dataCenter',
    marketingLabels: ['codegeist2017'],
    tags: {
      marketingLabels: []
    },
    logo: {
      highRes: '674735f8-2d0a-4e9b-bc20-d98ead6ca80b',
      image: '728df428-0533-475f-b507-ee48291e12d4'
    },
    releaseDate: 1554511621000,
    ratings: {
      avgStars: 2.909091,
      numRatings: 11
    },
    distribution: {
      activeInstalls: 10261,
      downloads: 4463,
      bundled: false
    },
    programs: {
      cloudFortified: {
        status: 'not_a_participant'
      },
      bugBountyParticipant: {
        cloud: {
          status: 'approved'
        },
        server: {
          status: 'approved'
        },
        dataCenter: {
          status: 'approved'
        }
      },
      runsOnAtlassian: {
        status: false
      }
    },
    vendor: {
      id: 85,
      name: 'Atlassian',
      partnerTier: {
        type: ''
      }
    }
  },
  environment: 'local',
  source: 'MPAC',
  hidePartnerDetails: false,
  onTileClick: () => null,
  tileRef: undefined,
  isAppInstalled: () => false,
  preferredHosting: 'cloud'
});
export const images = [{
  title: 'Highlight 1',
  caption: 'Highlight 1',
  summary: 'Highlight 1',
  image: {
    url: 'https://placehold.co/600x400',
    width: 1920,
    height: 1080
  },
  croppedImage: {
    url: 'https://placehold.co/600x400',
    width: 1920,
    height: 1080
  }
}, {
  title: 'Highlight 2',
  caption: 'Highlight 2',
  summary: 'Highlight 2',
  image: {
    url: 'https://placehold.co/600x400',
    width: 1920,
    height: 1080
  },
  croppedImage: {
    url: 'https://placehold.co/600x400',
    width: 1920,
    height: 1080
  }
}];
export const bundleDetailMock = {
  marketplaceStore: {
    bundleDetail: {
      productId: '123',
      developerId: 'developerId',
      name: 'name',
      logo: {
        altText: 'logo alt text',
        fileName: 'logo file name',
        height: 200,
        imageType: 'image type',
        url: 'https://placehold.co/200',
        width: 200
      },
      tagLine: 'tagLine',
      moreDetails: 'moreDetails',
      youtubeId: 'youtubeId',
      partner: {
        id: '2a68dc06-ca84-44c7-bbc4-0ccb512e458a'
      },
      heroImage: {
        altText: 'hero alt text',
        fileName: 'hero file name',
        height: 1000,
        imageType: 'image type',
        url: 'https://placehold.co/1000',
        width: 1000
      },
      supportDetails: {
        appStatusPage: 'appStatusPage',
        issueTracker: 'issueTracker',
        supportTicketSystem: 'supportTicketSystem',
        forums: 'forums',
        privacy: 'privacy'
      },
      vendorLinks: {
        documentation: 'documentation',
        learnMore: 'learnMore',
        eula: 'eula',
        purchase: 'purchase'
      },
      screenshots: [{
        caption: 'screenshot caption 1',
        image: {
          altText: 'screenshot image alt text 1',
          fileName: 'screenshot image file name 1',
          height: 200,
          imageType: 'image type 1',
          url: 'https://placehold.co/200',
          width: 200
        }
      }, {
        caption: 'screenshot caption 2',
        image: {
          altText: 'screenshot image alt text 2',
          fileName: 'screenshot image file name 2',
          height: 200,
          imageType: 'image type 2',
          url: 'https://placehold.co/200',
          width: 200
        }
      }],
      highlights: [{
        title: 'highlight title 1',
        caption: 'highlight caption 1',
        summary: 'highlight summary 1',
        screenshot: {
          caption: 'highlight screenshot caption 1',
          image: {
            altText: 'highlight screenshot image alt text 1',
            fileName: 'highlight screenshot image file name 1',
            height: 1000,
            imageType: 'image type 1',
            url: 'https://placehold.co/1000',
            width: 1000
          }
        },
        thumbnail: {
          altText: 'highlight thumbnail image alt text 1',
          fileName: 'highlight thumbnail image file name 1',
          height: 200,
          imageType: 'image type 1',
          url: 'https://placehold.co/200',
          width: 200
        }
      }, {
        title: 'highlight title 2',
        caption: 'highlight caption 2',
        summary: 'highlight summary 2',
        screenshot: {
          caption: 'highlight screenshot caption 2',
          image: {
            altText: 'highlight screenshot image alt text 2',
            fileName: 'highlight screenshot image file name 2',
            height: 1000,
            imageType: 'image type 2',
            url: 'https://placehold.co/1000',
            width: 1000
          }
        },
        thumbnail: {
          altText: 'highlight thumbnail image alt text 2',
          fileName: 'highlight thumbnail image file name 2',
          height: 200,
          imageType: 'image type 2',
          url: 'https://placehold.co/200',
          width: 200
        }
      }]
    }
  }
};